import { LoteOrcamento } from "app/types/pesquisa-orcamento/consultas/Lotes"
import globalMU from "globalMU"
import React from "react"

const estilosTabelas = require('../../../../../estilos/tabelas.module.scss').default

export type NotaFiscalLotesProps = {
    lotes: LoteOrcamento[]
}

export const NotaFiscalLotes = (props: NotaFiscalLotesProps) => {

    const headerTabela = () => {
        const mapHeader = ["Produto", "Descrição", "Lote", "Tonalidade", "Bitola", "Fabricação", "Quantidade"]

        return mapHeader.map((nome) => <th key={nome}>{nome}</th>)
    }

    const itensTabela = (lote: LoteOrcamento) => {
        const mapBody = [
            lote.CodigoProduto, lote.DescricaoProduto, lote.Nome, lote.Tonalidade,
            lote.Bitola, globalMU.formatDate(lote.Data),
            globalMU.formatarValorNumerico(Math.abs(lote.Quantidade), 3, false)
        ]

        return mapBody.map((nome, indice) => <td key={indice}>{nome}</td>)  
    }

    const tabelaLotes =
        <div className="_my-4">
            <table className={`_table _w-full _border-collapse ${estilosTabelas.tabela}`}>
                <thead>
                    <tr>
                        {headerTabela()}
                    </tr>
                </thead>
                <tbody>
                    {props.lotes.map((dado) => (
                        <tr key={`${dado.CodigoProduto}-${dado.Nome}`}>
                            {itensTabela(dado)}
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>

    return (
        <>
            {tabelaLotes}
        </>
    )
}